import i18n from '../i18n';
const { t } = i18n.global;

export const FORFAIT_SELECTOR = 'forfait';
export const RESTAURACION_SELECTOR = 'restauracion';
export const TRANSPORTE_SELECTOR = 'transporte';
export const SEGURO_SELECTOR = 'seguro';
export const ACTIVIDAD_SELECTOR = 'actividad';
export const FESTIVAL_SELECTOR = 'festival';
export const CLASES_SELECTOR = 'clases';
export const ALQUILER_SELECTOR = 'alquiler';
export const GREENFEE_SELECTOR = 'greenFee';
export const COMFORT_SELECTOR = 'comfort';
export const PERSONAL_SELECTOR = 'personal';

export const selectServiceText = {
  [FORFAIT_SELECTOR]: {
    titulo: t('servicios.forfait.titulo'),
    subtitulo: t('servicios.forfait.subtitulo'),
    icono: 'fa-solid fa-credit-card fa-2x',
  },
  [RESTAURACION_SELECTOR]: {
    titulo: t('servicios.comida.titulo'),
    subtitulo: t('servicios.comida.subtitulo'),
    icono: 'fa-solid fa-cutlery fa-2x',
  },
  [TRANSPORTE_SELECTOR]: {
    titulo: t('servicios.transporte.titulo'),
    subtitulo: t('servicios.transporte.subtitulo'),
    icono: 'fa-solid fa-van-shuttle fa-2x',
  },
  [SEGURO_SELECTOR]: {
    titulo: t('servicios.seguro.titulo'),
    subtitulo: t('servicios.seguro.subtitulo'),
    icono: 'fa-solid fa-notes-medical fa-2x',
  },
  [ACTIVIDAD_SELECTOR]: {
    titulo: t('servicios.actividad.titulo'),
    subtitulo: t('servicios.actividad.subtitulo'),
    icono: 'fa-solid fa-plus',
  },
  [CLASES_SELECTOR]: {
    titulo: t('servicios.clase.titulo'),
    subtitulo: t('servicios.clase.subtitulo'),
    icono: 'fa-solid fa-person-skiing fa-2x',
  },
  [ALQUILER_SELECTOR]: {
    titulo: t('servicios.alquiler.titulo'),
    subtitulo: t('servicios.alquiler.subtitulo'),
    icono: 'fa-solid fa-person-skiing-nordic fa-2x',
  },
  [GREENFEE_SELECTOR]: {
    titulo: t('servicios.greenFee.titulo'),
    subtitulo: t('servicios.greenFee.subtitulo'),
    icono: 'fa-solid fa-golf-ball-tee fa-2x',
  },
  [COMFORT_SELECTOR]: {
    titulo: t('servicios.relax.titulo'),
    subtitulo: t('servicios.relax.subtitulo'),
    icono: 'fa-solid fa-face-smile-beam fa-2x',
  },
  [PERSONAL_SELECTOR]: {
    titulo: t('servicios.personal.titulo'),
    subtitulo: t('servicios.personal.subtitulo'),
    icono: 'fa-solid fa-user-group fa-2x',
  },
  [FESTIVAL_SELECTOR]: {
    titulo: t('servicios.festival.titulo'),
    subtitulo: t('servicios.festival.subtitulo'),
    icono: 'fa-solid fa-music fa-2x',
  },
};
